import { useNavigate } from "react-router-dom";
import { Button, Stack, Title } from "@mantine/core";
import type { Detail } from "../../types/api";
import ModelThumbs from "../models/ModelThumbs";
import type { ModelPresenter } from "../models/presenter";

interface GenerateResultProps<TModel extends { id: string; url: string }> {
  data: Detail<TModel>;
  presenter: ModelPresenter<TModel>;
  detailPath: string;
}

/** The result block under a Generate form: original + model thumbnails and a link to the detail page. */
export default function GenerateResult<TModel extends { id: string; url: string }>({ data, presenter, detailPath }: GenerateResultProps<TModel>) {
  const navigate = useNavigate();
  return (
    <Stack gap="md">
      <Title order={4}>Result</Title>
      <ModelThumbs models={data.models} presenter={presenter} original={data.image} />
      <Button variant="light" onClick={() => navigate(detailPath)}>
        View full detail
      </Button>
    </Stack>
  );
}
